import {
  ADD_QUESTIONNAIRE,
  ADD_QUESTIONNAIRE_FAILED,
  ADD_QUESTIONNAIRE_SUCCESS,
  GET_QUESTIONNAIRE,
  GET_QUESTIONNAIRE_SUCCESS,
  GET_QUESTIONNAIRE_FAILED,
  RESET_QUESTIONNAIRE,
  UPDATE_QUESTIONNAIRE,
  UPDATE_QUESTIONNAIRE_SUCCESS,
  UPDATE_QUESTIONNAIRE_FAILED,
  POST_QUESTIONNAIRE_RESULT,
  POST_QUESTIONNAIRE_RESULT_SUCCESS,
  POST_QUESTIONNAIRE_RESULT_FAILED,
  POST_QUESTIONNAIRE_DESIGN,
  POST_QUESTIONNAIRE_DESIGN_SUCCESS,
  POST_QUESTIONNAIRE_DESIGN_FAILED,
  GET_QUESTIONNAIRE_LIST,
  GET_QUESTIONNAIRE_LIST_SUCCESS,
  GET_QUESTIONNAIRE_LIST_FAILED,
  OPEN_DELETE_QUESTIONNAIRE_MODAL,
  HIDE_DELETE_QUESTIONNAIRE_MODAL,
  DELETE_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE_SUCCESS,
  DELETE_QUESTIONNAIRE_FAILED,
  UPDATE_QUESTIONNAIRE_ORDER,
  UPDATE_QUESTIONNAIRE_ORDER_SUCCESS,
  UPDATE_QUESTIONNAIRE_ORDER_FAILED,
  RESET_QUESTIONNAIRE_LIST,
  GET_QUESTIONNAIRE_REPLY,
  GET_QUESTIONNAIRE_REPLY_SUCCESS,
  GET_QUESTIONNAIRE_REPLY_FAILED,
  RESET_QUESTIONNAIRE_REPLY,
  GET_QUESTIONNAIRE_SCORES,
  GET_QUESTIONNAIRE_SCORES_SUCCESS,
  GET_QUESTIONNAIRE_SCORES_FAILED,
  DELETE_QUESTIONNAIRE_SUBMISSION,
  DELETE_QUESTIONNAIRE_SUBMISSION_SUCCESS,
  DELETE_QUESTIONNAIRE_SUBMISSION_FAILED,
  UPDATE_QUESTIONNAIRE_MENU_ITEM,
  UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS,
  UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED,
  SET_UPDATE_FEATURE_ERROR_MODAL,
} from "./actionTypes"

export const addQuestionnaire = params => ({
  type: ADD_QUESTIONNAIRE,
  payload: params,
})

export const addQuestionnaireSuccess = response => ({
  type: ADD_QUESTIONNAIRE_SUCCESS,
  payload: response,
})

export const addQuestionnaireFailed = error => ({
  type: ADD_QUESTIONNAIRE_FAILED,
  payload: error,
})

export const getQuestionnaire = params => ({
  type: GET_QUESTIONNAIRE,
  payload: params,
})

export const getQuestionnaireSuccess = response => ({
  type: GET_QUESTIONNAIRE_SUCCESS,
  payload: response,
})

export const getQuestionnaireFailed = error => ({
  type: GET_QUESTIONNAIRE_FAILED,
  payload: error,
})

export const resetQuestionnaire = () => ({
  type: RESET_QUESTIONNAIRE,
  payload: {},
})

export const updateQuestionnaire = params => ({
  type: UPDATE_QUESTIONNAIRE,
  payload: params,
})

export const updateQuestionnaireSuccess = response => ({
  type: UPDATE_QUESTIONNAIRE_SUCCESS,
  payload: response,
})

export const updateQuestionnaireFailed = error => ({
  type: UPDATE_QUESTIONNAIRE_FAILED,
  payload: error,
})

export const postQuestionnaireResult = params => ({
  type: POST_QUESTIONNAIRE_RESULT,
  payload: params,
})

export const postQuestionnaireResultSuccess = response => ({
  type: POST_QUESTIONNAIRE_RESULT_SUCCESS,
  payload: response,
})

export const postQuestionnaireResultFailed = error => ({
  type: POST_QUESTIONNAIRE_RESULT_FAILED,
  payload: error,
})

export const postQuestionnaireDesign = params => ({
  type: POST_QUESTIONNAIRE_DESIGN,
  payload: params,
})

export const postQuestionnaireDesignSuccess = response => ({
  type: POST_QUESTIONNAIRE_DESIGN_SUCCESS,
  payload: response,
})

export const postQuestionnaireDesignFailed = error => ({
  type: POST_QUESTIONNAIRE_DESIGN_FAILED,
  payload: error,
})

export const getQuestionnaireList = params => ({
  type: GET_QUESTIONNAIRE_LIST,
  payload: params,
})

export const getQuestionnaireListSuccess = response => ({
  type: GET_QUESTIONNAIRE_LIST_SUCCESS,
  payload: response,
})

export const getQuestionnaireListFailed = error => ({
  type: GET_QUESTIONNAIRE_LIST_FAILED,
  payload: error,
})

export const resetQuestionnaireList = () => ({
  type: RESET_QUESTIONNAIRE_LIST,
  payload: {},
})

export const openDeleteQuestionnaireModal = () => ({
  type: OPEN_DELETE_QUESTIONNAIRE_MODAL,
  payload: {},
})

export const hideDeleteQuestionnaireModal = () => ({
  type: HIDE_DELETE_QUESTIONNAIRE_MODAL,
  payload: {},
})

export const deleteQuestionnaire = params => ({
  type: DELETE_QUESTIONNAIRE,
  payload: params,
})

export const deleteQuestionnaireSuccess = response => ({
  type: DELETE_QUESTIONNAIRE_SUCCESS,
  payload: response,
})

export const deleteQuestionnaireFailed = error => ({
  type: DELETE_QUESTIONNAIRE_FAILED,
  payload: error,
})

export const updateQuestionnaireOrder = params => ({
  type: UPDATE_QUESTIONNAIRE_ORDER,
  payload: params,
})

export const updateQuestionnaireOrderSuccess = response => ({
  type: UPDATE_QUESTIONNAIRE_ORDER_SUCCESS,
  payload: response,
})

export const updateQuestionnaireOrderFailed = error => ({
  type: UPDATE_QUESTIONNAIRE_ORDER_FAILED,
  payload: error,
})

export const getQuestionnaireReply = params => ({
  type: GET_QUESTIONNAIRE_REPLY,
  payload: params,
})

export const getQuestionnaireReplySuccess = response => ({
  type: GET_QUESTIONNAIRE_REPLY_SUCCESS,
  payload: response,
})

export const getQuestionnaireReplyFailed = error => ({
  type: GET_QUESTIONNAIRE_REPLY_FAILED,
  payload: error,
})

export const resetQuestionnaireReply = () => ({
  type: RESET_QUESTIONNAIRE_REPLY,
  payload: {},
})

export const getQuestionnaireScores = params => ({
  type: GET_QUESTIONNAIRE_SCORES,
  payload: params,
})

export const getQuestionnaireScoresSuccess = response => ({
  type: GET_QUESTIONNAIRE_SCORES_SUCCESS,
  payload: response,
})

export const getQuestionnaireScoresFailed = error => ({
  type: GET_QUESTIONNAIRE_SCORES_FAILED,
  payload: error,
})

export const deleteQuestionnaireSubmission = params => ({
  type: DELETE_QUESTIONNAIRE_SUBMISSION,
  payload: params,
})

export const deleteQuestionnaireSubmissionSuccess = response => ({
  type: DELETE_QUESTIONNAIRE_SUBMISSION_SUCCESS,
  payload: response,
})

export const deleteQuestionnaireSubmissionFailed = error => ({
  type: DELETE_QUESTIONNAIRE_SUBMISSION_FAILED,
  payload: error,
})

export const updateQuestionnaireMenuItem = params => ({
  type: UPDATE_QUESTIONNAIRE_MENU_ITEM,
  payload: params,
})

export const updateQuestionnaireMenuItemSuccess = response => ({
  type: UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS,
  payload: response,
})

export const updateQuestionnaireMenuItemFailed = error => ({
  type: UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED,
  payload: error,
})

export const setUpdateFeatureErrorModal = value => ({
  type: SET_UPDATE_FEATURE_ERROR_MODAL,
  payload: value,
})
